var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.80469 12.1904V6.82324H0V4.69043H1.80469V3.00293C1.80469 2.1123 2.05469 1.4248 2.55469 0.94043C3.05469 0.44043 3.71875 0.19043 4.54688 0.19043C5.21875 0.19043 5.76562 0.22168 6.1875 0.28418V2.18262H5.0625C4.64062 2.18262 4.35156 2.27637 4.19531 2.46387C4.07031 2.62012 4.00781 2.87012 4.00781 3.21387V4.69043H6L5.71875 6.82324H4.00781V12.1904H1.80469Z","fill":"white"}));
}

IconFacebookInline.defaultProps = {"width":"7","height":"13","viewBox":"0 0 7 13","fill":"none"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
